import styled from "styled-components";

// Mobile-only gradient container styles
export const AllContentContainer = styled.div`
  .container-gradient {
    position: relative;
    isolation: isolate;
    border-radius: 40px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), linear-gradient(0deg, rgba(252, 252, 252, 0.6), rgba(252, 252, 252, 0.6));
    box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.05) inset, 0px 20px 50px 30px rgba(61, 78, 83, 0.10);
    backdrop-filter: blur(15px);

    &::before {
      content: "";
      position: absolute;
      inset: -1px;
      border-radius: 40px;
      padding: 1px;
      background: linear-gradient(124deg, #FFF 7.86%, rgba(92, 143, 137, 0.40) 12.11%, rgba(92, 143, 137, 0.40) 88.58%, #FFF 92.83%);
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;
    }
    box-shadow: inset 0px 0px 50px 0px rgba(0, 0, 0, 0.05), 0px 20px 50px -20px rgba(0, 0, 0, 0.10);
   
  }
  .hotspot-content-item {
    >div {
    margin: 0;
    padding-left: 0;
    h4 {
        font-weight: 500;
    }
    }
  }
`;
